(function(){
  function initCatalog(){
    document.querySelectorAll('[data-pb-row]').forEach(function(row){
      row.addEventListener('click', function(e){
        if (e.target.closest('a, button, form, input, .pb-btn')) return;
        var open = row.classList.contains('open');
        document.querySelectorAll('[data-pb-row].open').forEach(function(r){ r.classList.remove('open'); });
        if (!open) row.classList.add('open');
      });
    });
  }
  function initGiftFilters(){
    var wrap = document.querySelector('.pb-gifts__filters');
    if (!wrap) return;
    var chips = wrap.querySelectorAll('.pb-chip');
    var lines = document.querySelectorAll('[data-pb-gift]');
    chips.forEach(function(chip){
      chip.addEventListener('click', function(){
        chips.forEach(function(c){ c.classList.remove('active'); });
        chip.classList.add('active');
        var f = chip.getAttribute('data-pb-filter');
        lines.forEach(function(line){
          var hasCat = line.getAttribute('data-cat') === 'true';
          var hasDog = line.getAttribute('data-dog') === 'true';
          var show = true;
          if (f === 'cat') show = hasCat;
          else if (f === 'dog') show = hasDog;
          else if (f === 'both') show = hasCat && hasDog;
          line.classList.toggle('pb-hidden', !show);
        });
      });
    });
  }
  function initSideRail(){
    var rail = document.querySelector('[data-pb-rail]');
    if (!rail) return;
    var dots = rail.querySelectorAll('.pb-side-rail__dot');
    var items = [];
    dots.forEach(function(dot){
      var id = dot.getAttribute('data-pb-jump');
      var el = id ? document.getElementById(id) : null;
      if (el) items.push({id: id, el: el, dot: dot});
      dot.addEventListener('click', function(){
        var t = id ? document.getElementById(id) : null;
        if (t) window.scrollTo({top: t.offsetTop - 80, behavior: 'smooth'});
      });
    });
    function onScroll(){
      var ref = window.scrollY + window.innerHeight * 0.35;
      var active = null;
      items.forEach(function(s){ if (ref >= s.el.offsetTop) active = s; });
      items.forEach(function(s){ s.dot.classList.toggle('active', s === active); });
    }
    window.addEventListener('scroll', onScroll, {passive: true});
    onScroll();
  }
  function initScrollCounter(){
    var c = document.querySelector('[data-pb-scroll-counter]');
    if (!c) return;
    var bar = c.querySelector('.bar i');
    var idxEl = c.querySelector('[data-pb-scroll-idx]');
    var labelEl = c.querySelector('[data-pb-scroll-label]');
    var labels = {'catalog':'SHOP','promise':'PROMISE','voice':'VOICE','gifts':'GIFTS','reviews':'REVIEWS','contact':'HELLO'};
    var ids = ['catalog','promise','voice','gifts','reviews','contact'];
    var sections = ids.map(function(id){ return {id: id, el: document.getElementById(id)}; }).filter(function(s){ return s.el; });
    var total = sections.length + 1;
    function update(){
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      var pct = Math.min(1, Math.max(0, window.scrollY / Math.max(1, docH)));
      if (bar) bar.style.width = (pct * 100) + '%';
      var ref = window.scrollY + window.innerHeight * 0.35;
      var idx = 1, label = 'TOP';
      sections.forEach(function(s, i){ if (ref >= s.el.offsetTop) { idx = i + 2; label = labels[s.id] || s.id.toUpperCase(); } });
      if (idxEl) idxEl.textContent = String(idx).padStart(2,'0') + ' / ' + String(total).padStart(2,'0');
      if (labelEl) labelEl.textContent = label;
    }
    window.addEventListener('scroll', update, {passive: true});
    window.addEventListener('resize', update);
    update();
  }
  function initCountryMenu(){
    var trigger = document.querySelector('[data-pb-country]');
    var menu = document.querySelector('[data-pb-country-menu]');
    if (!trigger || !menu) return;
    trigger.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      menu.hidden = !menu.hidden;
    });
    document.addEventListener('click', function(e){
      if (!menu.hidden && !menu.contains(e.target) && !trigger.contains(e.target)) {
        menu.hidden = true;
      }
    });
  }
  /* ---- AJAX cart drawer ---------------------------------------------- */
  var PBCart = (function(){
    var root, body, footEl, emptyEl, subEl, panel, lastFocus;
    function money(cents, currency){
      try { return new Intl.NumberFormat(undefined, {style:'currency', currency: currency || 'EUR'}).format((cents||0)/100); }
      catch(e){ return ((cents||0)/100).toFixed(2); }
    }
    function setCounts(n){
      document.querySelectorAll('[data-pb-cart-count]').forEach(function(el){
        el.textContent = n;
        if (el.classList.contains('pb-cart-dot')) el.classList.toggle('is-empty', !n);
      });
    }
    function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
    function lineHTML(item, currency){
      var img = item.image
        ? '<img src="' + item.image.replace(/(_\d+x\d+)?(\.[a-z]+)(\?.*)?$/i, '_160x160$2') + '" alt="" loading="lazy">'
        : '<div class="pb-cart-line__img-ph">' + esc(item.product_title).toUpperCase() + '</div>';
      var variant = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<span class="pb-cart-line__variant">' + esc(item.variant_title) + '</span>' : '';
      // Line price + any active cart/discount savings (cart.js exposes line-level prices).
      var onSale = item.original_line_price && item.final_line_price && item.original_line_price > item.final_line_price;
      var priceHTML = '';
      if (onSale) priceHTML += '<span class="was">' + money(item.original_line_price, currency) + '</span>';
      priceHTML += '<span class="now' + (onSale ? ' is-sale' : '') + '">' + money(item.final_line_price, currency) + '</span>';
      if (item.quantity > 1) priceHTML += '<span class="each">' + money(item.final_price, currency) + ' each</span>';
      return '' +
        '<article class="pb-cart-line" data-pb-line data-key="' + esc(item.key) + '">' +
          '<a class="pb-cart-line__img" href="' + esc(item.url) + '">' + img + '</a>' +
          '<div class="pb-cart-line__main">' +
            '<div class="pb-cart-line__top">' +
              '<h3 class="pb-cart-line__name"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></h3>' +
              '<button type="button" class="pb-cart-line__remove" data-pb-remove aria-label="Remove ' + esc(item.product_title) + '">' +
                '<svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13"/></svg>' +
              '</button>' +
            '</div>' +
            variant +
            '<div class="pb-cart-line__bottom">' +
              '<div class="pb-cart-qty">' +
                '<button type="button" data-pb-qty="dec" aria-label="Decrease quantity">−</button>' +
                '<span data-pb-qty-val>' + item.quantity + '</span>' +
                '<button type="button" data-pb-qty="inc" aria-label="Increase quantity">+</button>' +
              '</div>' +
              '<div class="pb-cart-line__prices">' + priceHTML + '</div>' +
            '</div>' +
          '</div>' +
        '</article>';
    }
    function updateShip(cart){
      var shipEl = root.querySelector('[data-pb-ship]');
      if (!shipEl) return; // bar disabled (threshold 0 or not rendered)
      var threshold = parseInt(root.getAttribute('data-pb-ship-threshold'), 10) || 0;
      if (threshold <= 0 || cart.item_count === 0){ shipEl.hidden = true; return; }
      shipEl.hidden = false;
      var fill = shipEl.querySelector('[data-pb-ship-fill]');
      var msg = shipEl.querySelector('[data-pb-ship-msg]');
      var remaining = threshold - cart.total_price;
      var pct = Math.max(0, Math.min(1, cart.total_price / threshold));
      if (fill) fill.style.width = (pct * 100) + '%';
      if (remaining > 0){
        shipEl.classList.remove('is-unlocked');
        if (msg) msg.innerHTML = 'Add <b>' + money(remaining, cart.currency) + '</b> for free shipping';
      } else {
        shipEl.classList.add('is-unlocked');
        if (msg) msg.innerHTML = '<b>Free shipping unlocked</b> — nice one';
      }
    }
    function render(cart){
      if (!body) return;
      setCounts(cart.item_count);
      updateShip(cart);
      if (cart.item_count === 0){
        body.innerHTML = '';
        body.hidden = true;
        if (emptyEl) emptyEl.hidden = false;
        if (footEl) footEl.hidden = true;
      } else {
        body.hidden = false;
        if (emptyEl) emptyEl.hidden = true;
        if (footEl) footEl.hidden = false;
        body.innerHTML = cart.items.map(function(it){ return lineHTML(it, cart.currency); }).join('');
        if (subEl) subEl.textContent = money(cart.total_price, cart.currency);
      }
      body.removeAttribute('aria-busy');
    }
    function refresh(){
      return fetch('/cart.js', {headers:{'Accept':'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(cart){ render(cart); return cart; });
    }
    function open(){
      if (!root) return;
      lastFocus = document.activeElement;
      root.hidden = false;
      // force reflow so the transition runs
      void root.offsetWidth;
      root.classList.add('is-open');
      document.body.classList.add('pb-cart-open');
      if (panel) panel.focus();
      refresh();
    }
    function close(){
      if (!root) return;
      root.classList.remove('is-open');
      document.body.classList.remove('pb-cart-open');
      window.setTimeout(function(){ root.hidden = true; }, 340);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function add(id, qty, btn){
      if (!id) return;
      if (btn){ btn.disabled = true; btn.classList.add('is-loading'); }
      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({id: id, quantity: qty || 1})
      })
      .then(function(r){ if(!r.ok){ return r.json().then(function(e){ throw e; }); } return r.json(); })
      .then(function(){ return refresh(); })
      .then(function(){
        if (btn){ btn.classList.remove('is-loading'); btn.classList.add('is-done'); btn.disabled = false;
          window.setTimeout(function(){ btn.classList.remove('is-done'); }, 1100); }
        open();
      })
      .catch(function(err){
        if (btn){ btn.disabled = false; btn.classList.remove('is-loading'); }
        var msg = (err && err.description) ? err.description : 'Could not add to bag. Please try again.';
        window.alert(msg);
      });
    }
    function change(key, qty){
      if (body) body.classList.add('is-loading');
      fetch('/cart/change.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({id: key, quantity: qty})
      })
      .then(function(r){ return r.json(); })
      .then(function(cart){ render(cart); })
      .catch(function(){ refresh(); })
      .then(function(){ if (body) body.classList.remove('is-loading'); });
    }
    function init(){
      root = document.querySelector('[data-pb-cart]');
      if (!root) return;
      body = root.querySelector('[data-pb-cart-body]');
      footEl = root.querySelector('[data-pb-cart-foot]');
      emptyEl = root.querySelector('[data-pb-cart-empty]');
      subEl = root.querySelector('[data-pb-cart-subtotal]');
      panel = root.querySelector('.pb-cart__panel');

      // Open triggers (header bag, etc.)
      document.addEventListener('click', function(e){
        var opener = e.target.closest('[data-pb-cart-open]');
        if (opener){ e.preventDefault(); open(); return; }
        var closer = e.target.closest('[data-pb-cart-close]');
        if (closer){ e.preventDefault(); close(); return; }
        var addBtn = e.target.closest('[data-pb-add]');
        if (addBtn){ e.preventDefault(); add(addBtn.getAttribute('data-pb-add'), parseInt(addBtn.getAttribute('data-pb-qty-add'),10) || 1, addBtn); return; }
      });

      // Qty + remove within the drawer
      body.addEventListener('click', function(e){
        var line = e.target.closest('[data-pb-line]');
        if (!line) return;
        var key = line.getAttribute('data-key');
        var cur = parseInt(line.querySelector('[data-pb-qty-val]').textContent, 10) || 1;
        if (e.target.closest('[data-pb-remove]')){ change(key, 0); return; }
        var q = e.target.closest('[data-pb-qty]');
        if (q){
          var dir = q.getAttribute('data-pb-qty');
          change(key, dir === 'inc' ? cur + 1 : Math.max(0, cur - 1));
        }
      });

      document.addEventListener('keydown', function(e){
        if (e.key === 'Escape' && root.classList.contains('is-open')) close();
      });
    }
    return {init: init, open: open, add: add, refresh: refresh};
  })();

  function init(){ initCatalog(); initGiftFilters(); initSideRail(); initScrollCounter(); initCountryMenu(); PBCart.init(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
